import React from 'react'
import ImageZoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

const Zoom = React.memo(({ children, ...rest }) => <ImageZoom {...rest}>{children}</ImageZoom>);

export { Zoom }
